var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.947762,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#37828B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4478 25V27C19.8565 27 18.3303 27.6321 17.2051 28.7574C16.0799 29.8826 15.4478 31.4087 15.4478 33H13.4478C13.4478 30.8783 14.2906 28.8434 15.7909 27.3431C17.2912 25.8429 19.326 25 21.4478 25ZM21.4478 24C18.1328 24 15.4478 21.315 15.4478 18C15.4478 14.685 18.1328 12 21.4478 12C24.7628 12 27.4478 14.685 27.4478 18C27.4478 21.315 24.7628 24 21.4478 24ZM21.4478 22C23.6578 22 25.4478 20.21 25.4478 18C25.4478 15.79 23.6578 14 21.4478 14C19.2378 14 17.4478 15.79 17.4478 18C17.4478 20.21 19.2378 22 21.4478 22ZM27.4478 32.5L24.5088 34.045L25.0698 30.773L22.6928 28.455L25.9788 27.977L27.4478 25L28.9178 27.977L32.2028 28.455L29.8258 30.773L30.3858 34.045L27.4478 32.5Z",
    fill: "#37828B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/Active Users.3706f8be.svg";
export { ForwardRef as ReactComponent };